var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencySymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 922.01 479.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,\n      .cls-2 {\n        fill: #000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.56,478.8h-125.86c41.94-.01,83.93,0,125.86,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M922.01,236.09l-59.34,95.95-333.24-.07c25.34,15.62,52.07,30.01,80.14,40.23,7.12,2.58,30.02,10.71,36.24,10.71h179.3l-56.94,96.38c-12.64.7-651.61-.33-755.19-.49-5.78,0-9.89,0-12.13,0h-.85l55.44-95.88h343.63c.12,0-26.38-33.78-38.46-50.94l-264.7-.49,56.43-95.39h173.31c-.8-61.59,16.04-121.33,49.53-172.7,31.83-48.8,63.2-75.17,125.05-58.28,41.3,11.29,78.52,39.73,107.65,70.21l-36.5,142.79c-1.77.36-12.58-12.88-16.95-17.5-37.63-39.81-102.37-90.88-160.53-66.57-14.35,6-29.47,19.14-30.02,35.91-.73,22.61,27.02,49.43,40.69,65.64l517.44.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencySymbol);
export default __webpack_public_path__ + "static/media/currencySymbol.268703d256ed2eab7a92b061e1fcc290.svg";
export { ForwardRef as ReactComponent };